import { Resource } from "../resource/resource.model";

export class PreferenceDashboard  extends Resource {
    id: string;
    name: string;
    value: string;
    
}